import { alpha, Box } from "@mui/material";
import type { FC, ReactNode } from "react";
import { EyebrowLabel } from "../../../../../components/UIToolkit/molecules/EyebrowLabel";
import { ALPHA, RADIUS } from "../../../../../theme/tokens";

type Props = { title: string; tinted?: boolean; testId: string; children: ReactNode };

/** A titled group of a rule's conditions; `tinted` sets the approval gate apart from what the rule selects. */
export const AutoApproveRuleZone: FC<Props> = ({ title, tinted = false, testId, children }) => (
	<Box
		component="section"
		aria-label={title}
		data-testid={testId}
		sx={(theme) => ({
			display: "flex",
			flexDirection: "column",
			gap: 1.5,
			minWidth: 0,
			py: 1.5,
			// Only the tinted zone is a surface; the plain one keeps the row's own left edge.
			px: tinted ? 2 : 0,
			borderRadius: `${RADIUS.CONTROL}px`,
			...(tinted && { backgroundColor: alpha(theme.palette.primary.main, ALPHA.SELECTED_OVERLAY) }),
		})}
	>
		<EyebrowLabel component="h3" sx={{ color: "primary.dark" }}>
			{title}
		</EyebrowLabel>
		{children}
	</Box>
);
